import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';
import * as userActionTypes from '../../users-mgmt/action-mgr/actionTypes';

import stationsSearchForm from './stationsSearchForm';
import stationScreen from './stationScreen';

const byId = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_STATIONS_SUCCESS:
      return action.byId;
    case actionTypes.ARCHIVE_STATION_SUCCESS:
    case actionTypes.RESTORE_STATION_SUCCESS:
      return {
        ...state,
        [action.stationId]: {
          ...state[action.stationId],
          status: action.status
        }
      };
    default:
      return state;
  }
}

const ids = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SEARCH_STATIONS_SUCCESS:
      return action.ids;
    default:
      return state;
  }
}

const isSearching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_STATIONS_REQUEST:
      return true;
    case actionTypes.SEARCH_STATIONS_SUCCESS:
    case actionTypes.SEARCH_STATIONS_FAILURE:
      return false;
    default:
      return state;
  }
}

const isSaving = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CREATE_STATION_REQUEST:
    case actionTypes.UPDATE_STATION_REQUEST:
      return true;
    case actionTypes.CREATE_STATION_SUCCESS:
    case actionTypes.CREATE_STATION_FAILURE:
    case actionTypes.UPDATE_STATION_SUCCESS:
    case actionTypes.UPDATE_STATION_FAILURE:
      return false;
    default:
      return state;
  }
}

const isArchiving = (state = false, action) => {
  switch (action.type) {
    case actionTypes.ARCHIVE_STATION_REQUEST:
      return true;
    case actionTypes.ARCHIVE_STATION_SUCCESS:
    case actionTypes.ARCHIVE_STATION_FAILURE:
      return false;
    default:
      return state;
  }
}

const isRestoring = (state = false, action) => {
  switch (action.type) {
    case actionTypes.RESTORE_STATION_REQUEST:
      return true;
    case actionTypes.RESTORE_STATION_FAILURE:
    case actionTypes.RESTORE_STATION_SUCCESS:
      return false;
    default:
      return state;
  }
}

const selectedStationId = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_STATION:
      return action.station.id;
    default:
      return state;
  }
}

const selectedStations = (state = [], action) => {
  switch (action.type) {
    case userActionTypes.SELECT_USER:
      return action.user.stationList;
    case actionTypes.ADD_STATION_TO_SELECTIONS:
      return [
        ...state,
        action.station
      ];
    case actionTypes.REMOVE_STATION_FROM_SELECTIONS:
      return [
        ...state.slice(0, action.index),
        ...state.slice(action.index + 1)
      ];
    case actionTypes.CLEAR_SELECTIONS:
    case userActionTypes.ADD_NEW_USER:
      return [];
    default:
      return state;
  }
}

const selectedFields = (state = [], action) => {
  switch (action.type) {
    case actionTypes.ADD_FIELDS_TO_SELECTIONS:
      return [
        ...state,
        action.field
      ];
    case actionTypes.REMOVE_FIELDS_FROM_SELECTIONS:
      var index = state.indexOf(action.key);
      return [
        ...state.slice(0, index),
        ...state.slice(index + 1)
      ];
    case actionTypes.CLEAR_FIELDS_SELECTIONS:
      return [];
    default:
      return state;
  }
}

export default combineReducers({
  byId,
  ids,
  isSearching,
  isSaving,
  isArchiving,
  isRestoring,
  selectedStationId,
  stationsSearchForm,
  stationScreen,
  selectedStations,
  selectedFields
});

const getStationsState = state => state.stations;

export const getStations = state => {
  const stationsState = getStationsState(state);
  return stationsState.ids.map(id => stationsState.byId[id]);
}

export const getIsSearching = state => getStationsState(state).isSearching;

export const getIsSaving = state => getStationsState(state).isSaving;

export const getIsArchiving = state => getStationsState(state).isArchiving;

export const getIsRestoring = state => getStationsState(state).isRestoring;

export const getSelectedStationId = state => getStationsState(state).selectedStationId;

export const getSelectedStations = state => getStationsState(state).selectedStations;

export const getSelectedFields = state => getStationsState(state).selectedFields;